import React, { FC, useMemo } from 'react'
import { AsH2, Text } from '@/atoms/Text'
import { useGBExperiment } from '@/experimentation'
import { useLocale } from '@/utils/LocaleUtil'
import { Translate, useTranslate } from '@/utils/translate/translate-client'
import { SoldOutInfoIconTooltip } from '@/views/TicketCheckoutViews/ShowtimesView/components/SoldOutInfoIconTooltip'

interface Props {
  soldOut: number
  soldLastDay: number
}
const VenuesSoldOutAlert: FC<Props> = ({ soldOut, soldLastDay }) => {
  const { t } = useTranslate('tickets')
  const { locale } = useLocale()

  const [showSoldLastDay, ready] = useGBExperiment('show-tickets-sold-last-day', false)

  const alertText = useMemo(() => {
    if (showSoldLastDay) {
      const formattedTicketsSold = new Intl.NumberFormat(locale).format(soldLastDay)
      return (
        <Translate i18nKey="soldOutShowtimesNationwideWithSoldLastDay" t={t} values={{ formattedTicketsSold, soldOut }}>
          <span className="photon-caption-xl font-semibold">{{ formattedTicketsSold }}</span> tickets sold in the last
          day and <span className="photon-caption-xl font-semibold">{{ soldOut }}</span> sold out theaters nationwide.
          Selling Fast! <SoldOutInfoIconTooltip />
        </Translate>
      )
    }
    return (
      <Translate i18nKey="soldOutShowtimesNationwide" t={t} values={{ soldOut }}>
        <span className="photon-caption-xl font-semibold">{{ soldOut }}</span> sold out theaters nationwide. Selling
        Fast! <SoldOutInfoIconTooltip />
      </Translate>
    )
  }, [locale, showSoldLastDay, soldLastDay, soldOut, t])

  if (!ready) return null

  return (
    <div
      className="experiment-hidden inline-block rounded-lg border-l-4 border-error-300 bg-error-100 px-2 py-3"
      role="alert"
    >
      <Text as={AsH2} className="photon-caption-md md:photon-caption-lg">
        {alertText}
      </Text>
    </div>
  )
}

export default VenuesSoldOutAlert
